// Angular Imports
import { Component, DestroyRef, OnInit, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { environment } from '@environment'
// Store Imports
import { Store } from '@ngrx/store'
import { selectLogged } from '@store/selectors'
// Thirdparty Imports
import { debounceTime } from 'rxjs'

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	logged = signal<boolean>(false)

	constructor(private _store: Store, private _destroyRef: DestroyRef) {}

	ngOnInit(): void {
		this._store
			.select(selectLogged)
			.pipe(takeUntilDestroyed(this._destroyRef), debounceTime(1000))
			.subscribe({
				next: (logged: boolean) => this.logged.update(() => logged),
			})

		// const urlParams = new URLSearchParams(window.location.search)

		// let token = localStorage.getItem('access-token')
		// let refresh_token = localStorage.getItem('refresh-token')

		// if (!token) {
		// 	console.log('reassigned')

		// 	token = urlParams.get('access-token')
		// 	refresh_token = urlParams.get('refresh-token')!
		// }

		// if (!token) {
		// 	console.log('it is logged', token, refresh_token)

		// 	// window.location.replace(`${environment.apiurl}/login/oauth2/code/azure`)
		// } else {
		// 	console.log('it is not logged', token, refresh_token)

		// 	localStorage.setItem('access-token', token)
		// 	localStorage.setItem('refresh-token', refresh_token!)
		// }
	}
}
